import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#F6A704', // Primary color
    },
    secondary: {
      main: '#5604F6', 
    },
  },
  typography: {
    fontFamily: '"Urbanist", sans-serif', 
    urbanist400: {
      fontFamily: '"Urbanist", sans-serif',
      fontWeight: 400,
    },
    urbanist500: {
      fontFamily: '"Urbanist", sans-serif',
      fontWeight: 500,
    },
    urbanist600: {
      fontFamily: '"Urbanist", sans-serif',
      fontWeight: 600,
    },
    urbanist700: {
      fontFamily: '"Urbanist", sans-serif',
      fontWeight: 700,
    },
    urbanist800: {
      fontFamily: '"Urbanist", sans-serif',
      fontWeight: 800,
    },
    inter400: {
      fontFamily: '"Inter", sans-serif',
      fontWeight: 400,
    },
    inter500: {
      fontFamily: '"Inter", sans-serif',
      fontWeight: 500,
    },
  },
  breakpoints: {
    values: {
      xs: 0,    // Small devices (phones, portrait)
      sm: 600,  // Medium devices (tablets, small laptops)
      md: 960,  // Large devices (laptops)
      lg: 1280, // Extra large devices (desktops)
      xl: 1920, // Very large devices (big screens)
    },
  },
});

export default theme;
